<template>
    <div class="pc-bg-container">
        <div class="login-container">
            <div class="login-box">
                <div v-show="false" class="box-left">
                    <!-- <img class="logo" :src="logo" alt=""> -->
                </div>
                <div class="box-right">
                    <!-- <div class="sys-name">{{ systemName }}</div> -->
                    <form class="login-form" v-if="oprType == 'login'">
                        <div class="login-tabs">
                            <div class="login-type-item">
                                <div :class="loginInfo.loginType == 'pwd' ? 'active' : ''" class="item-text"
                                    @click="changeLoginType('pwd')">密码登录
                                </div>
                            </div>
                            <div class="login-type-item ">
                                <div :class="loginInfo.loginType == 'code' ? 'active' : ''" class="item-text"
                                    @click="changeLoginType('code')">手机登录
                                </div>
                            </div>
                        </div>
                        <div class="input-row" v-if="loginInfo.loginType == 'pwd'">
                            <el-input v-model="loginInfo.account" placeholder="请输入账号"
                                class="el-input-fifty-height"></el-input>
                        </div>
                        <div class="input-row" v-if="loginInfo.loginType == 'pwd'">
                            <el-input v-model="loginInfo.password" placeholder="请输入密码" class="el-input-fifty-height"
                                show-password></el-input>
                        </div>

                        <div class="input-row" v-if="loginInfo.loginType == 'code'">
                            <el-input v-model="loginInfo.phone" placeholder="请输入手机号"
                                class="el-input-fifty-height"></el-input>
                        </div>
                        <div class="input-row" v-if="loginInfo.loginType == 'code'">
                            <el-input v-model="loginInfo.imageCode" placeholder="请输入验证码" class="el-input-fifty-height"
                                maxlength="6">
                            </el-input>
                            <img @click="createRandomCodeImage()" class="code-image" :src="codeFilePath" />
                        </div>
                        <div class="input-row" v-if="loginInfo.loginType == 'code'">
                            <el-input v-model="loginInfo.code" placeholder="请输入验证码" class="el-input-fifty-height"
                                maxlength="6">
                            </el-input>
                            <el-button class="code-btn" type="text" @click="SendMobileCode('login')"
                                :disabled="'发送验证码' != btnText">{{ btnText }}</el-button>
                        </div>

                        <div class="input-row" style="margin-bottom: 15px;">
                            <el-button type="primary" @click="loginOnclick()" native-type="submit"
                                :loading="loginBtnIsLoading">登 录</el-button>
                        </div>
                    </form>
                    <form v-if="oprType == 'register'" class="register-form">
                        <div class="input-row">
                            <el-input v-model="registerForm.account" placeholder="用户名"
                                class="el-input-fifty-height"></el-input>
                        </div>
                        <div class="input-row">
                            <el-input v-model="registerForm.password" placeholder="密码长度不能小于8位"
                                class="el-input-fifty-height" show-password @input="verifyPwd"
                                @change="verifyPwd"></el-input>
                            <span style="display: block; margin: 3px 0;color: #999;">数字、大写字母、小写字母、特殊字符至少包含3种</span>
                            <el-progress :percentage="pwdFormatStep" :show-text="false"
                                :status="pwdFormatStepStatus"></el-progress>
                        </div>
                        <div class="input-row">
                            <el-input v-model="registerForm.conPassword" placeholder="确认密码"
                                class="el-input-fifty-height" show-password></el-input>
                        </div>

                        <div class="input-row">
                            <el-input v-model="registerForm.phone" placeholder="手机号" type="tel" maxlength="11"
                               class="el-input-fifty-height"></el-input>
                        </div>
                        <div class="input-row">
                            <el-input v-model="registerForm.imageCode" placeholder="验证码" maxlength="6"
                                class="el-input-fifty-height"></el-input>
                            <img @click="createRandomCodeImage()" class="code-image" :src="codeFilePath" />
                        </div>
                        <div class="input-row">
                            <el-input v-model="registerForm.code" placeholder="短信验证码" maxlength="6"
                                class="el-input-fifty-height"></el-input>
                            <el-button class="code-btn" type="text" @click="SendMobileCode('register')"
                                :disabled="'发送验证码' != btnText">{{ btnText }}</el-button>
                        </div>

                        <div class="input-row" style="margin-bottom: 15px;">
                            <el-button type="primary" @click="registerOnclick()" native-type="submit"
                                :loading="loginBtnIsLoading">注 册</el-button>
                        </div>
                    </form>
                    <div class="fotget-pwd-div">
                        <span v-if="oprType == 'register'" @click="changeOprType('login')">已有账号，去登录></span>
                        <span v-if="oprType == 'login'" @click="changeOprType('register')">没有账号，去注册></span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UserInfoService from "@/request-server/request-services/userinfo-services.js";
import UtilsCommon from '@/utils/utils-common';
import BrowserStorage from '@/utils/utils-browser-storage';
import systemServices from "../../request-server/request-services/system-services";
import Url from '../../request-server/request-url';
export default {
    props: ["redirect"],
    data() {
        return {
            btnText: '发送验证码',
            codeId: '',
            baseStr: '',
            codeFilePath: '',
            systemName: "全民跳绳赛事管理系统",
            logo: UtilsCommon.getAssetsFiles("images/logo.jpg"),
            //登录信息
            loginInfo: {
                loginType: 'pwd',
                account: "",
                password: "",
                phone: '',
                code: '',
                imageCode: ''
            },
            registerForm: {
                account: '',
                password: '',
                conPassword: '',
                phone: '',
                code: '',
                imageCode: ''
            },
            oprType: 'login',
            loginBtnIsLoading: false,
            redirectUrl: this.redirect,
            selectedLoginType: '',
            pwdFormatStep: 0,
            pwdFormatStepStatus: 'exception',
            lockSecond: 0,
            interval: null
        };
    },
    methods: {
        //登录点击事件
        loginOnclick() {
            if (this.loginInfo.loginType == 'pwd') {
                if (!this.loginInfo.account) {
                    this.$message.error("请输入账号");
                    return;
                }
                if (!this.loginInfo.password) {
                    this.$message.error("请输入密码");
                    return;
                }
            } else {
                if (!this.loginInfo.phone) {
                    this.$message.error("请输入手机号");
                    return;
                }
                if (!this.loginInfo.code) {
                    this.$message.error("请输入验证码");
                    return;
                }
            }

            this.loginBtnIsLoading = true;
            let data = {
                LoginType:this.loginInfo.loginType,
                LoginName:this.loginInfo.account,
                LoginPwd:this.loginInfo.password,
                Phone:this.loginInfo.phone,
                Code:this.loginInfo.code
            }
            UserInfoService.userLoginV2(data)
                .then(resData => {
                    this.$store.commit("loginin", resData.data.LoginToken);
                    this.$store.commit("matchIdCookie", '');
                    let beforeUrl = this.redirectUrl;
                    if ((resData.data.AccountType == 2 || resData.data.AccountType == 0) && !beforeUrl) {
                        //显示选择报名端/管理端的选项弹框
                        this.$confirm('请选择您要登录终端', '提示', {
                            confirmButtonText: '后台管理',
                            cancelButtonText: '报名管理',
                            type: 'warning'
                        }).then(() => {
                            this.$router.replace('/mainpage');
                        }).catch(() => {
                            this.$router.replace('/contestant');
                        });

                    } else if ((resData.data.AccountType == 0 || resData.data.AccountType == 2) && beforeUrl) {
                        //显示选择报名端/管理端的选项弹框
                        this.$router.replace(beforeUrl);
                    }
                    else if (resData.data.AccountType == 11 && beforeUrl) {
                        //用户登录，并且有回调路由，判断是否是管理端的路由，是则跳转报名端
                        if (beforeUrl.indexOf('mainpage') > -1) {
                            this.$router.replace('/contestant');
                        } else {
                            this.$router.replace(beforeUrl);
                        }
                    } else if (resData.data.AccountType == 11) {
                        this.$router.replace('/contestant');
                    }
                })
                .finally(() => {
                    this.loginBtnIsLoading = false;
                });
        },
        registerOnclick() {
            if (!this.registerForm.account) {
                this.$message({
                    message: '请输入用户名',
                    type: 'warning'
                });
                return;
            }

            if (!this.registerForm.password) {
                this.$message({
                    message: '请输入密码',
                    type: 'warning'
                });
                return;
            }

            if (this.pwdFormatStep < 100) {
                this.$message({
                    message: '密码格式不正确',
                    type: 'warning'
                });
                return;
            }

            if (this.registerForm.password != this.registerForm.conPassword) {
                this.$message({
                    message: '密码与确认密码不一致，请重新输入',
                    type: 'warning'
                });
                return;
            }

            if (!this.registerForm.phone) {
                this.$message({
                    message: '请输入手机号',
                    type: 'warning'
                });
                return;
            }

            if (!this.registerForm.code) {
                this.$message({
                    message: '请输入验证码',
                    type: 'warning'
                });
                return;
            }


            let data = {
                LoginName:this.registerForm.account,
                LoginPwd:this.registerForm.password,
                Phone:this.registerForm.phone,
                Code:this.registerForm.code
            }
            UserInfoService.contestantRegisterV2(data).then(resData => {
                if (resData.code == 0) {
                    this.$message({
                        message: resData.data,
                        type: 'success'
                    });
                    this.changeOprType('login')
                }
            })


        },
        verifyPwd() {
            let formatSucc = 0;
            let lenSucc = 0;

            if (/\d/.test(this.registerForm.password)) formatSucc++;
            if (/[a-z]/.test(this.registerForm.password)) formatSucc++;
            if (/[A-Z]/.test(this.registerForm.password)) formatSucc++;
            if (/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.registerForm.password)) formatSucc++;

            if (this.registerForm.password.length >= 8) lenSucc = 1;
            let formatStep = formatSucc >= 3 ? 75 : formatSucc * 25;
            this.pwdFormatStep = formatStep + lenSucc * 25;

            this.pwdFormatStepStatus = this.pwdFormatStep == 100 ? 'success' : 'warning'
        },
        changeLoginType(type) {
            this.loginInfo.loginType = type;
            this.loginInfo.account = "";
            this.loginInfo.password = "";
            this.loginInfo.phone = '';
            this.loginInfo.code = '';
            this.loginInfo.imageCode = '';
            this.btnText = "发送验证码";
            if (this.interval != null) {
                clearInterval(this.interval);
                this.interval
            }
            this.createRandomCodeImage();
        },
        changeOprType(type) {
            console.log(type);
            this.oprType = type;
            this.loginInfo = {
                loginType: 'pwd',
                account: "",
                password: "",
                phone: '',
                code: '',
                imageCode: ''
            };
            this.registerForm = {
                account: '',
                password: '',
                conPassword: '',
                phone: '',
                code: '',
                imageCode: ''
            }
            this.btnText = "发送验证码";
            clearInterval(this.interval)
            this.interval = null;
            this.createRandomCodeImage();
            this.verifyPwd();
        },
        createRandomCodeImage() {
            this.codeId = '';
            this.base64Str = '';
            systemServices.createRandomCodeImage().then(resData => {
                if (resData.code === 0) {
                    this.codeId = resData.data.code;
                    this.codeFilePath = Url.getDownloadBaseUrl() + 'exportfiles/' + resData.data.fileName;
                }
            })
        },
        SendMobileCode(type) {
            let code = "";
            let phone = "";
            if (type == 'login') {
                code = this.loginInfo.imageCode;
                phone = this.loginInfo.phone;
            } else if (type == 'register') {
                code = this.registerForm.imageCode;
                phone = this.registerForm.phone;
            }

            if (phone == '') {
                this.$message.warning('请输入手机号');
                return;
            }

            const phoneRegex = /^1[3-9]\d{9}$/;
            if (!phoneRegex.test(phone)){
                this.$message.warning('手机号格式不正确');
                return;
            }

            if (code == '') {
                this.$message.warning('请输入图片验证码');
                return;
            }


            let data = {
                codeId:this.codeId,
                code:code,
                phone:phone,
                type:type
            }

            UserInfoService.sendMobileCode(data).then(resData => {
                if(resData.code == 0){
                    this.lockSecond = 60;
                    this.btnText = this.lockSecond + 's';
                    this.interval = setInterval(() => {
                        if (this.lockSecond > 0) {
                            this.lockSecond--;
                            this.btnText = this.lockSecond + 's';
                        } else {
                            this.btnText = '发送验证码';
                            clearInterval(this.interval);
                            this.interval = null;
                        }
                    }, 1000);
                }
            }) 
        }

    },
    created() {
        this.createRandomCodeImage();
    }
};
</script>

<style lang="scss" scoped>
.pc-bg-container {
    width: 100%;
    height: 100%;
    // background-color: #387cbd;
    // background: linear-gradient(#559ae7, #3a8be6);

    background: url("../../assets/images/login-bg.png") no-repeat 0 0 /100% 100%;
    position: relative;
    overflow: hidden;

    .login-container {
        width: 1600px;
        height: 800px;
        // background: url("../../assets/images/bg.jpg") no-repeat 0 0 /100% 100%;
        position: relative;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);

        .login-box {
            // width: 904px;
             width: 400px;
            height: 504px;
            overflow: hidden;
            position: absolute;
            top: 250px;
            right: 10%;
            background: transparent;
            border-radius: 5px;

            .box-left {
                float: left;
                width: 518px;
                height: 504px;
                background: url("../../assets/images/page-left.jpg") no-repeat 0 0 /100% 100%;
                position: relative;

                .logo {
                    width: 57px;
                    height: 57px;
                    position: absolute;
                    top: 48px;
                    left: 37px;
                }
            }

            .box-right {
                float: left;
                width: 386px;
                height: 504px;
                background: #fff;
                // text-align: center;

                .sys-name {
                    font-size: 43px;
                    font-family: SourceHanSansCN-Light;
                    color: #56a9ff;
                    // margin-left: 52px;
                    margin-top: 58px;
                    text-align: center;
                }

                .welcome-text {
                    font-family: SourceHanSansCN-Light;
                    font-size: 20px;
                    color: #b2b4b9;
                    // margin-left: 122px;
                    margin-top: 6px;
                    text-align: center;
                }

                .login-form {
                    .login-tabs {
                        display: flex;
                        height: 100px;
                        line-height: 100px;
                        width: 70%;

                        .login-type-item {
                            width: 50%;
                            text-align: center;
                            font-size: 20px;
                            color: #999;

                            .item-text {
                                width: fit-content;
                                margin: 0 auto;
                                height: 70px;
                            }

                            .item-text:hover {
                                cursor: pointer;
                            }

                            .active {
                                border-bottom: 3px solid green;
                            }
                        }

                    }

                    .input-row {
                        position: relative;

                        .code-btn {
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 100px;
                            height: 100%;
                            font-size: 14px;
                        }

                        .code-image {
                            position: absolute;
                            top: 5px;
                            right: 5px;
                            width: 100px;
                            height: 90%;
                            font-size: 14px;
                        }
                    }
                }

                .register-form {
                    margin-top: 65px !important;

                    .input-row {
                        position: relative;
                        height: initial !important;
                        margin-bottom: 10px !important;

                        ::v-deep(.el-input__inner) {
                            height: 40px !important;
                        }

                        .code-btn {
                            position: absolute;
                            top: 0;
                            right: 0;
                            width: 100px;
                            font-size: 14px;
                        }

                        .code-image {
                            position: absolute;
                            top: 5px;
                            right: 5px;
                            width: 100px;
                            height: 80%;
                            font-size: 14px;
                        }
                    }
                }

                form {
                    width: 100%;
                    margin-top: 45px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;

                    .check-row {
                        width: 274px;
                        margin-bottom: 29px;
                        margin-top: -4px;

                        // height: 48px;
                    }

                    .input-row {
                        // width: 100%;
                        width: 274px;
                        height: 48px;
                        // text-align: center;
                        margin-bottom: 29px;

                        // &:last-child {
                        //     margin-bottom: 25px;
                        // }

                        button {
                            width: 100%;
                            // height: 48px;
                            // font-family: SourceHanSansCN-Light;
                            font-size: 20px;
                            display: block;
                        }
                    }
                }
            }
        }
    }
}

.fotget-pwd-div {
    text-align: right;
    width: 274px;
    margin: 0 auto 29px auto;

    >a {
        font-size: 13px;
        color: #999999;
    }
}

.fotget-pwd-div:hover {
    cursor: pointer;
    text-decoration: underline;
    color: #56a9ff;
}

.forget-pwd-dig-sel-div {
    text-align: center;

    div {
        margin: 18px;
    }
}

.forget-pwd-dig-form-div {
    ::v-deep {
        .el-input {
            margin: 10px 0;
        }
    }

    >div:nth-child(2) {
        ::v-deep {
            .el-input {
                width: 60%;
                margin-bottom: 0;
            }

            .el-button {
                margin-left: 8px;
            }
        }
    }

    >p {
        color: #999999;
        font-size: 12px;
    }

    .commit-div {
        text-align: center;
        margin: 38px 0 0 0;
    }

}

::v-deep {
    // .el-input-fifty-height input {
    //     // width: 274px;
    //     height: 48px;
    //     line-height: 48px;
    // }

    .el-checkbox__label {
        color: #71757f;
        // color: #409eff;
    }
}
</style>
